"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireWildcard(require("react"));
var _reactNative = require("react-native");
var _MaterialCommunityIcons = _interopRequireDefault(require("react-native-vector-icons/MaterialCommunityIcons"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _styles = require("@sart/styles");
var _TextInput = _interopRequireDefault(require("./TextInput"));
var _Label = _interopRequireDefault(require("./Label"));
var _Text = _interopRequireDefault(require("./Text"));
var _ErrorMessage = _interopRequireDefault(require("./ErrorMessage"));
var _Space = _interopRequireDefault(require("./Space"));
var _excluded = ["forwardedRef", "label", "value", "footer", "icon", "alignIcon", "error", "hideError", "showErrorAndFooter", "style", "wrapperStyle", "focusedStyle", "labelStyle", "labelFocusedStyle", "footerStyle", "footerErrorStyle", "footerErrorContainerStyle", "errorStyle", "placeholderColor", "iconStyle", "allowShowHidePassword"],
  _excluded2 = ["color"];
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function TextInputExtended(props) {
  var forwardedRef = props.forwardedRef,
    label = props.label,
    value = props.value,
    footer = props.footer,
    icon = props.icon,
    alignIcon = props.alignIcon,
    error = props.error,
    hideError = props.hideError,
    showErrorAndFooter = props.showErrorAndFooter,
    style = props.style,
    wrapperStyle = props.wrapperStyle,
    focusedStyle = props.focusedStyle,
    labelStyle = props.labelStyle,
    labelFocusedStyle = props.labelFocusedStyle,
    footerStyle = props.footerStyle,
    footerErrorStyle = props.footerErrorStyle,
    footerErrorContainerStyle = props.footerErrorContainerStyle,
    errorStyle = props.errorStyle,
    placeholderColor = props.placeholderColor,
    iconStyle = props.iconStyle,
    allowShowHidePassword = props.allowShowHidePassword,
    rest = (0, _objectWithoutProperties2["default"])(props, _excluded);
  var currentRef = (0, _react.useRef)();
  var inputRef = forwardedRef || currentRef;
  var _useState = (0, _react.useState)(false),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    showPassword = _useState2[0],
    setShowPassword = _useState2[1];
  var toggleShowPassword = function toggleShowPassword() {
    setShowPassword(!showPassword);
  };

  // BUG: There's an know bug on react-native
  // that does not update text color on focus change

  // TextInput secureTextEntry color bug #22781
  // https://github.com/facebook/react-native/issues/22781

  // HACK: filter color changes

  function safeSecureTextEntryColoring() {
    for (var _len = arguments.length, styles = new Array(_len), _key = 0; _key < _len; _key++) {
      styles[_key] = arguments[_key];
    }
    var style = _reactNative.StyleSheet.flatten(styles);
    if (props.secureTextEntry) {
      var color = style.color,
        _rest = (0, _objectWithoutProperties2["default"])(style, _excluded2);
      return _rest;
    } else {
      return style;
    }
  }
  var wrapperStyles = [styles.wrapper, wrapperStyle];
  var inputStyles = [styles["default"], style, icon && (alignIcon === 'left' ? styles.withIconLeft : styles.withIconRight), safeSecureTextEntryColoring(error && styles.error, error && errorStyle)];
  var focusedStyles = [focusedStyle, safeSecureTextEntryColoring(error && styles.error, error && errorStyle)];
  var labelStyles = [styles.label, labelStyle];
  var footerStyles = [styles.footer, footerStyle];
  var footerErrorStyles = [styles.footerError, footerErrorStyle];
  var footerErrorContainerStyles = [styles.footerErrorContainer, footerErrorContainerStyle];
  var placeholderTextColor = error ? _styles.colors.errorTransparent : placeholderColor ? placeholderColor : _styles.colors.subtle;
  // icon should be positioned relative to the input container (not the whole wrapper which may grow
  // when an error message is shown). Do not apply label-based top offset here.
  var iconStyles = icon && [iconStyle ? iconStyle : styles.icon, alignIcon === 'left' ? styles.iconLeft : styles.iconRight];
  function handleIconRender() {
    if (typeof icon === "function") {
      var iconColor = function () {
        var focused = inputRef && inputRef.current && inputRef.current.isFocused && inputRef.current.isFocused();
        if (error) {
          if (value) return _styles.colors.error;else return _styles.colors.errorTransparent;
        }
        if (focused) return _styles.colors.feature;
        if (value) return _styles.colors.common;else return _styles.colors.subtle;
      }();
      return icon({
        color: iconColor
      });
    } else {
      return icon;
    }
  }
  var showError = error && !hideError;
  var showFooter = showErrorAndFooter ? footer : footer && !error;
  return /*#__PURE__*/_react["default"].createElement(_reactNative.View, {
    style: wrapperStyles
  }, label && /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_Label["default"], {
    style: labelStyles
    // onPress={handleFocus}
  }, label), /*#__PURE__*/_react["default"].createElement(_Space["default"], {
    height: 8
  })), /*#__PURE__*/_react["default"].createElement(_reactNative.View, {
    style: styles.inputContainer
  }, /*#__PURE__*/_react["default"].createElement(_TextInput["default"], (0, _extends2["default"])({
    ref: inputRef,
    value: value,
    style: inputStyles,
    focusedStyle: focusedStyles,
    placeholderTextColor: placeholderTextColor,
    secureTextEntry: allowShowHidePassword ? !showPassword : false
  }, rest)), allowShowHidePassword && /*#__PURE__*/_react["default"].createElement(_MaterialCommunityIcons["default"], {
    name: showPassword ? 'eye-off' : 'eye',
    size: 24,
    color: "#aaa",
    style: styles.showHideIcon,
    onPress: toggleShowPassword
  }), /*#__PURE__*/_react["default"].createElement(_reactNative.View, {
    style: iconStyles,
    pointerEvents: "none"
  }, icon && handleIconRender())), (showError || showFooter) && /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_Space["default"], {
    height: 8
  }), /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    style: footerErrorContainerStyles
  }, showError && /*#__PURE__*/_react["default"].createElement(_ErrorMessage["default"], {
    style: footerErrorStyles
  }, error, showFooter ? '. ' : ''), showFooter && /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    style: footerStyles
  }, footer))));
}

// Forwards the component reference
// https://reactjs.org/docs/forwarding-refs.html
var _default = exports["default"] = /*#__PURE__*/_react["default"].forwardRef(function (props, ref) {
  return /*#__PURE__*/_react["default"].createElement(TextInputExtended, (0, _extends2["default"])({}, props, {
    forwardedRef: ref
  }));
});
var iconSize = 24;
var iconPadding = _styles.sizes.selectStyleByDefaultSize({
  small: 4,
  medium: 8,
  large: 12
});
var styles = _reactNative.StyleSheet.create({
  inputContainer: {
    position: 'relative',
    width: '100%'
  },
  wrapper: {},
  label: {
    // marginBottom: 8
  },
  "default": {
    // marginBottom: 8
  },
  error: {
    color: _styles.colors.error,
    borderColor: _styles.colors.error
  },
  withIconLeft: {
    paddingLeft: iconPadding + iconSize + iconPadding
  },
  withIconRight: {
    paddingRight: iconPadding + iconSize + iconPadding
  },
  icon: _objectSpread({
    position: 'absolute',
    justifyContent: 'center',
    alignItems: 'center',
    width: iconPadding + iconSize + iconPadding
  }, _styles.sizes.selectStyleByDefaultSize({
    small: {
      height: 18 + 4 * 2
    },
    medium: {
      height: 19 + 8 * 2
    },
    large: {
      height: 23 + 12 * 2
    }
  })),
  iconWithLabel: {
    top: iconSize + 8 + 1
  },
  iconLeft: {
    left: 1
  },
  iconRight: {
    right: 1
  },
  footer: {
    // textTransform: 'capitalize',
  },
  footerError: {
    textAlign: 'left'
  },
  footerErrorContainer: {
    // marginBottom: 8
  },
  showHideIcon: {
    position: 'absolute',
    right: '5%',
    top: '45%',
    transform: [{
      translateY: -iconSize / 2
    }],
    zIndex: 1,
    padding: 4
  }
});
TextInputExtended.defaultProps = {
  alignIcon: 'right'
};
TextInputExtended.propTypes = {
  label: _propTypes["default"].string,
  value: _propTypes["default"].string,
  alignIcon: _propTypes["default"].oneOf(['left', 'right']),
  footer: _propTypes["default"].any,
  onChange: _propTypes["default"].func,
  onChangeText: _propTypes["default"].func,
  style: _propTypes["default"].any,
  wrapperStyle: _propTypes["default"].any,
  labelStyle: _propTypes["default"].any,
  footerStyle: _propTypes["default"].any
};